import React, { createContext, PropsWithChildren, useContext } from 'react';

const Context = createContext<string | null>(null);

export const useIdPrefix = (suffix: string | null = null) => {
  const prefix = useContext(Context);
  return prefix ? `${prefix}-${suffix ?? ''}` : undefined;
};

type IdContextProviderProps = {
  prefix: string;
};

export const IdPrefixProvider = ({ children, prefix }: PropsWithChildren<IdContextProviderProps>) => {
  return <Context.Provider value={prefix}>{children}</Context.Provider>;
};
